import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import UpdateRepository from "../Repositories/UpdateRepository";

class UpdateBloc {
  detailChannel = new Subject();
  listPensionChannel = new Subject();
  listStopChannel = new Subject();
  updateChannel = new Subject();
  repository = new UpdateRepository();

  constructor() {
    this.detailChannel.next({ status: apiResponse.INITIAL });
    this.updateChannel.next({ status: apiResponse.INITIAL });
    this.listPensionChannel.next({ status: apiResponse.INITIAL });
    this.listStopChannel.next({ status: apiResponse.INITIAL });
  }

  fetchDetail = async (query) => {
    try {
      this.detailChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDetail(query)
        .then((result) => {
          this.detailChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.detailChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribe");
    }
  };

  fetchTypePension = async (query) => {
    try {
      this.listPensionChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchTypePension(query)
        .then((result) => {
          this.listPensionChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.listPensionChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribe");
    }
  };

  fetchTypeStop = async (query) => {
    try {
      this.listStopChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchTypeStop(query)
        .then((result) => {
          this.listStopChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.listStopChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribe");
    }
  };

  fetchUpdate = async (query) => {
    try {
      this.updateChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchUpdate(query)
        .then((result) => {
          this.updateChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.updateChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribe");
    }
  };
}

export default UpdateBloc;
